import {Component, EventEmitter, inject, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {NZ_DRAWER_DATA, NzDrawerRef} from 'ng-zorro-antd/drawer';
import {ProjectUtilsService} from '../../services/project-utils.service';
import {ProjectContainer} from '../../../../shared/models/project-container';
import {ContainerTypes, KeyValueGroup, ToastConfig} from '@app/shared';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {GlobalValuesService} from '../../../../core/services/global-values.service';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import { DrawerEscapeBlockerService, ProjectService } from '@app/core';
import {NzNotificationService} from 'ng-zorro-antd/notification';
import {finalize} from 'rxjs';

@Component({
  selector: 'app-container-detail-drawer',
  standalone: false,

  templateUrl: './container-detail-drawer.component.html',
  styleUrl: './container-detail-drawer.component.less',
})
export class ContainerDetailDrawerComponent implements OnInit, OnDestroy {
  nzData: { container: ProjectContainer; readonly: boolean } =
    inject(NZ_DRAWER_DATA);

  @Output() updateContainer = new EventEmitter<ProjectContainer>();

  containerForm: FormGroup;

  typeList: ContainerTypes[] = [];

  creatingContainer: boolean = false;

  toastConfig: ToastConfig = {
    icon: 'check_circle',
    iconColor: '#6CDA75',
    content: 'Proyecto creado correctamente.',
    showUndo: false,
  };

  notRef: any;
  @ViewChild('notificationTmpl') notificationTmpl: any;

  constructor(
    private drawerRef: NzDrawerRef<string>,
    private projectService: ProjectService,
    public ps: ProjectUtilsService,
    public gs: GlobalValuesService,
    private fb: FormBuilder,
    private notificationService: NzNotificationService,
    private drawerEscapeBlocker: DrawerEscapeBlockerService,
  ) {
    this.containerForm = this.fb.group({
      containerRef: ['', Validators.required],
      containerTypeId: ['', Validators.required],
    });

    gs.containerTypes$.pipe(takeUntilDestroyed()).subscribe((value) => {
      this.typeList = value;
    });
  }

  ngOnInit() {
    this.containerForm.reset(this.nzData.container);

    // Registrar handler nativo en fase de captura para interceptar Escape
    this.drawerEscapeBlocker.block();
  }

  close(): void {
    this.drawerRef.close(this.nzData);
  }

  setKeyValueData(): KeyValueGroup[] {
    return [
      {
        name: 'data',
        layout: 'normal',
        items: [
          {
            parentObject: this.nzData.container,
            component: 'ContainerDetailDrawerComponent',
            label: 'Ref. Contenedor',
            noWrap: false,
            editable: false,
            required: true,
            type: 'text',
            path: 'containerRef',
            value: this.nzData.container!.containerRef,
          },
          {
            parentObject: this.nzData.container.containerType,
            component: 'ContainerDetailDrawerComponent',
            label: 'Tipo',
            noWrap: false,
            editable: false,
            required: true,
            type: 'text',
            path: 'description',
            value: this.nzData.container!.containerType?.description,
          },

          // TODO: Revisar bien la logica de estos dos
          // {
          //   label: 'Servicio',
          //   parentObject: this.nzData.container,
          //   component: 'ContainerDetailDrawerComponent',
          //   noWrap: false,
          //   editable: false,
          //   required: false,
          //   type: 'btn',
          //   path: 'service.name',
          //   value: {
          //     label: this.nzData.container.service?.name,
          //     sufix: 'open_in_new',
          //     link: environment.baseUrl + '/project/detail/' + this.ps.selectedProject?.id+ '/service/' + this.nzData.container.service?.id
          //   }
          // },
          // {
          //   label: 'Orden',
          //   parentObject: this.nzData.container,
          //   component: 'ContainerDetailDrawerComponent',
          //   noWrap: false,
          //   editable: false,
          //   required: false,
          //   type: 'btn',
          //   path: 'serviceOrder.reference',
          //   value: {
          //     label: this.nzData.container.serviceOrder?.reference,
          //     sufix: 'open_in_new',
          //     link: environment.baseUrl + '/project/detail/' + this.ps.selectedProject?.id+ '/service/' + this.nzData.container.service?.id
          //   }
          // },
        ],
      },
    ];
  }

  editContainer() {
    this.creatingContainer = true;

    const patchParams = {
      ...this.containerForm.value,
      id: this.nzData.container.id,
    };

    this.projectService
      .patchProjectContainer(patchParams)
      .pipe(finalize(() => this.showNotification()))
      .subscribe({
        next: (rsp) => {
          this.nzData.container = { ...rsp.data };
          this.updateContainer.emit(rsp.data);
          this.toastConfig = {
            icon: 'check_circle',
            iconColor: '#6CDA75',
            content: 'Contenedor editado.',
            showUndo: false,
          };
        },
        error: (e) => {
          console.error(e);
          this.toastConfig = {
            icon: 'dangerous',
            iconColor: '#CB2A2F',
            content: 'Error al editar el contenedor!',
            showUndo: false,
          };
        },
      });
  }

  showNotification(): void {
    this.creatingContainer = false;
    this.close();
    this.notRef = this.notificationService.create(
      'blank',
      '',
      this.notificationTmpl,
      { nzPlacement: 'bottomRight' },
    );
  }

  ngOnDestroy(): void {
    // Remover listener nativo si fue registrado
    this.drawerEscapeBlocker.unblock();
  }
}
